"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _ItinerarySegmentBanner = _interopRequireDefault(require("./ItinerarySegment/ItinerarySegmentBanner"));
exports.ItinerarySegmentBanner = _ItinerarySegmentBanner.default;
var _ItineraryBadgeList = _interopRequireWildcard(require("./ItineraryBadgeList"));
exports.ItineraryBadgeList = _ItineraryBadgeList.default;
exports.ItineraryBadgeListItem = _ItineraryBadgeList.ItineraryBadgeListItem;
var _ItinerarySegment = _interopRequireDefault(require("./ItinerarySegment"));
exports.ItinerarySegment = _ItinerarySegment.default;
var _ItinerarySeparator = _interopRequireDefault(require("./ItinerarySeparator"));
exports.ItinerarySeparator = _ItinerarySeparator.default;
var _ItineraryStatus = _interopRequireDefault(require("./ItineraryStatus"));
exports.ItineraryStatus = _ItineraryStatus.default;
var _ItinerarySegmentStop = _interopRequireDefault(require("./ItinerarySegment/ItinerarySegmentStop"));
exports.ItinerarySegmentStop = _ItinerarySegmentStop.default;
var _ItinerarySegmentDetail = _interopRequireDefault(require("./ItinerarySegment/ItinerarySegmentDetail"));
exports.ItinerarySegmentDetail = _ItinerarySegmentDetail.default;
var _context = require("./context");
var _tailwind = require("../common/tailwind");
const Itinerary = ({
  children,
  dataTest,
  spaceAfter,
  id
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: spaceAfter && _tailwind.spaceAfterClasses[spaceAfter],
    "data-test": dataTest,
    id: id
  }, /*#__PURE__*/React.createElement(_context.ItineraryProvider, null, children));
};
var _default = exports.default = Itinerary;